export enum ResourceType{
  Image = "Image",
  Article = "Article",
  Document = "Document",
  Video = "Video"
}
